import "./index.scss";

export const Modal = ({
  isOpen,
  onBackdropClick,
  header,
  children,
  customClassName,
  ...props
}) => {
  return (
    <div
      className={`modal ${isOpen ? "open" : "closed"} ${customClassName}`}
      {...props}
    >
      <div className="modal-backdrop" onClick={onBackdropClick} />
      <div className="modal-container">
        {header && <div className="modal-header">{header}</div>}
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};
